module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_B.310dd6c3.jpg";